import { render, staticRenderFns } from "./Icono.vue?vue&type=template&id=084ebd9e&scoped=true"
import script from "./Icono.vue?vue&type=script&lang=js"
export * from "./Icono.vue?vue&type=script&lang=js"
import style0 from "./Icono.vue?vue&type=style&index=0&id=084ebd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ebd9e",
  null
  
)

export default component.exports